<template>
    <footer role="contentinfo" aria-label="Footer" class="hide-on-print">
        <div class="container-fluid footer-wrapper">
            <div class="container">
                <div class="row">
                    <address
                        class="col-md-3"
                        itemscope="itemscope"
                        itemtype="https://schema.org/Organization"
                    >
                        <strong>HAVE QUESTIONS?</strong>
                        <div class="row mt-2">
                            <div class="col-1">
                                <span class="fi cdc-icon-email x24"></span>
                            </div>
                            <div class="col">
                                <span class="pl-1" itemprop="url">
                                    <a href="mailto:BRFSS2@cdc.gov"
                                        >Email BRFSS Help Desk</a
                                    >
                                </span>
                            </div>
                        </div>
                    </address>
                    <div class="col-md-3 mt-3 mt-md-0">
                        <strong>CDC INFORMATION</strong>
                        <ul>
                            <li>
                                <a href="https://www.cdc.gov/about/default.htm"
                                    >About CDC</a
                                >
                            </li>
                            <li>
                                <a href="https://jobs.cdc.gov">Jobs</a>
                            </li>
                            <li>
                                <a href="https://www.cdc.gov/funding"
                                    >Funding</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.cdc.gov/Other/policies.html"
                                    >Policies</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.cdc.gov/other/plugins/index.html"
                                    >File Viewers &amp; Players</a
                                >
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-3">
                        <ul>
                            <li>
                                <a href="https://www.cdc.gov/other/privacy.html"
                                    >Privacy</a
                                >
                            </li>
                            <li>
                                <a href="https://www.cdc.gov/od/foia">FOIA</a>
                            </li>
                            <li>
                                <a
                                    href="https://www.cdc.gov/eeo/nofearact/index.htm"
                                    >No Fear Act</a
                                >
                            </li>
                            <li>
                                <a href="https://oig.hhs.gov">OIG</a>
                            </li>
                            <li>
                                <a
                                    href="https://www.cdc.gov/other/nondiscrimination.html"
                                    >Nondiscrimination</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.cdc.gov/contact/accessibility.html"
                                    >Accessibility</a
                                >
                            </li>
                            <li>
                                <a
                                    href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html"
                                    >Vulnerability Disclosure Policy</a
                                >
                                |
                                <a
                                    href="https://www.hhs.gov/es/vulnerability-disclosure-policy/index.html"
                                    >Español</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid agency-footer">
            <div class="container">
                <div
                    class="row"
                    itemscope="itemscope"
                    itemtype="https://schema.org/Organization"
                >
                    <div class="col-md-6 mt-1 mt-md-0">
                        <span
                            class="value"
                            itemprop="contactPoint"
                            itemscope="itemscope"
                            itemtype="https://schema.org/ContactPoint"
                        >
                            <span itemprop="url">
                                <a href="https://www.hhs.gov">
                                    U.S. Department of Health &amp; Human
                                    Services
                                </a>
                            </span>
                        </span>
                    </div>
                    <div class="col-md-3 mt-1 mt-md-0">
                        <span
                            class="value"
                            itemprop="contactPoint"
                            itemscope="itemscope"
                            itemtype="https://schema.org/ContactPoint"
                        >
                            <span itemprop="url">
                                <a href="https://www.usa.gov/">USA.gov</a>
                            </span>
                        </span>
                    </div>
                    <!-- <div class="col-md-3 mt-1 mt-md-0">
                        <span class="value">
                            <span>
                                <a
                                    href="https://www.cdc.gov/Other/disclaimer.html"
                                    class="footer-ext"
                                >CDC Website Exit Disclaimer</a>
                                <span class="sr-only">external icon</span>
                                <span class="fi cdc-icon-external x16" aria-hidden="true"></span>
                            </span>
                        </span>
                    </div>-->
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
/* eslint spaced-comment: 'off' */

export default {
    data: () => {
        return {};
    },
    methods: {}
};
</script>

<style scoped src="@/assets/styles/bootstrap-grid.css"></style>

<style scoped>
/* @import '@/assets/styles/bootstrap-grid.css'; */
footer {
    box-sizing: border-box;
}
footer .footer-wrapper {
    font-size: 13px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    margin-top: 1rem;
    color: #fff;
    background-color: #333;
}

footer .footer-wrapper .footer-slim ul.list-inline {
    text-align: center;
}

footer .footer-wrapper .footer-slim ul.list-inline li {
    display: inline-block;
}

footer .footer-wrapper .footer-slim span {
    display: inline-block;
}

@media only screen and (max-width: 1200px) {
    footer .footer-wrapper .footer-slim ul.list-inline {
        text-align: left;
    }

    footer .footer-wrapper .footer-slim ul.list-inline li {
        display: block;
        float: none;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1200px) {
    footer .footer-wrapper .footer-slim ul.list-inline {
        -moz-columns: 2;
        columns: 2;
        width: 100%;
    }
}

@media only screen and (max-width: 991px) {
    footer .footer-wrapper .footer-slim {
        margin-bottom: 2.6rem;
    }
}

footer .footer-wrapper span {
    display: block;
}

footer .footer-wrapper svg {
    width: 24px;
    height: 24px;
}

footer .footer-wrapper a {
    color: #fff;
    text-decoration: none;
}

footer .footer-wrapper a:hover {
    text-decoration: underline;
}

footer .footer-wrapper .connect-iconsa:hover {
    text-decoration: none;
}

footer .footer-wrapper .connect-icons .list-inline li a span.fi {
    width: 24px;
    height: 24px;
}

footer .footer-wrapper li {
    margin-bottom: 3px;
}

footer .footer-wrapper ul {
    padding-left: 0;
    list-style-type: none;
}

footer .footer-wrapper ul.list-inline {
    display: inline-block;
    margin-bottom: 3px;
}

footer .footer-wrapper ul.list-inline li {
    float: left;
    margin-right: 10px;
}

footer .footer-wrapper ul.list-inline li img {
    width: 24px;
}

footer .footer-wrapper ul.list-inline li.rounded-circle {
    background-color: #fff;
    padding: 7px;
    margin-right: 7px;
}

strong {
    font-weight: bolder;
}

footer .agency-footer {
    font-size: 13px;
    padding-top: 0.5rem;
    padding-bottom: 3rem;
    margin-bottom: 1rem;
}
footer .agency-footer a {
    color: #000;
    text-decoration: none;
}
footer .agency-footer a:hover {
    text-decoration: underline;
}
footer .agency-footer a.footer-ext svg {
    fill: #000;
    float: left;
}
footer .agency-footer a.footer-ext svg + span {
    display: block;
    overflow: hidden;
}
footer .agency-footer a.footer-ext svg {
    fill: #000;
}

footer .language-footer {
    background: white;
    padding-top: 1rem;
}
@media only screen and (max-width: 991px) {
    footer .language-footer {
        margin-bottom: 3rem !important;
    }
}
footer .language-footer strong {
    font-size: 13px;
    color: #333;
}
footer .language-footer strong a {
    color: #333;
}
footer .language-footer span a {
    color: #333;
}
</style>
